import { render, staticRenderFns } from "./StudentAddModal.vue?vue&type=template&id=4a161d7d&"
import script from "./StudentAddModal.vue?vue&type=script&lang=js&"
export * from "./StudentAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StudentAddModal.vue"
export default component.exports